import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

function RastreoDialog({ open, onConfirm, onCancel }) {
  const [codigo, setCodigo] = useState('');
  const [link, setLink] = useState('');

  const handleConfirm = () => {
    onConfirm(codigo, link);
    setCodigo('');
    setLink('');
  };

  const handleCancel = () => {
    onCancel();
    setCodigo('');
    setLink('');
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Datos de rastreo</DialogTitle>
      <DialogContent>
        <TextField
          label="Código de rastreo (opcional)"
          fullWidth
          margin="normal"
          value={codigo}
          onChange={e => setCodigo(e.target.value)}
        />
        <TextField
          label="Link de rastreo (opcional)"
          fullWidth
          margin="normal"
          value={link}
          onChange={e => setLink(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

RastreoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default RastreoDialog; 